import React from "react"

const Arrow = ({ rotation = 0 }: { rotation: number }) => (
  <svg
    width="24px"
    height="24px"
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    style={{ transform: `rotate(${rotation}deg)` }}
  >
    <path fill="var(--arrowColor)" d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
  </svg>
)

export default Arrow
